import VoiceCampaign from './voice_campaign'
import EmailCampaign from './email_campaign'
import SMSCampaign from './sms_campaign'

const cards = {
  email_campaign: { component: EmailCampaign },
  sms_campaign: { component: SMSCampaign },
  voice_campaign: { component: VoiceCampaign }
}

export default cards
